<script setup lang="ts">
  import { computed } from 'vue';
  import { useRoute, useRouter } from 'vue-router';

  import { useRouteMeta } from '@ui/composables/useRouteMeta';
  import { cn } from '@ui/utils/utils';

  import TabsTrigger from './TabsTrigger.vue';

  export interface RoutedTabItem<T> {
    icon?: string;
    label?: string;
    query?: Record<string, any>;
    route: T;
  }

  interface Props {
    routedTabItem: RoutedTabItem<any>;
  }

  const props = defineProps<Props>();

  const route = useRoute();
  const { getMetaIcon, getMetaLabel } = useRouteMeta(useRouter());

  // Determine which icon to use:
  // - If icon property explicitly exists (even if undefined), use it
  // - Otherwise, fall back to route metadata
  const iconToUse = computed(() => {
    if ('icon' in props.routedTabItem) {
      return props.routedTabItem.icon;
    }
    return getMetaIcon(props.routedTabItem.route);
  });
</script>

<template>
  <TabsTrigger
    :value="routedTabItem.route"
    :query="routedTabItem.query"
    route-to-value
    class="routed-tab-trigger"
  >
    <i
      v-if="iconToUse"
      :class="cn('fa', iconToUse, route.name === routedTabItem.route ? 'fas' : 'far')"
    />
    <span>
      {{ routedTabItem.label ?? getMetaLabel(routedTabItem.route) }}
    </span>
  </TabsTrigger>
</template>

<style scoped lang="postcss"></style>
